import SearchIcon from 'assets/icons/searchIcon.svg';
import { observer } from 'mobx-react';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import './drugSearchBar.modue.scss';
import { useDrugSearchBar } from './useDrugSearchBar';

const DrugSearchBar = () => {
  const {
    drugSearchInput,
    isAllDrugsLoading,
    handleFilterDrugSearch,
    isConceptsListLoading,
    filteredDrugMoleculesForSearch,
    isSearchButtonDisabled,
    handleDrugSearchInputChange,
    handleSearch,
    handleEnterKeyDownDrugSearchField,
  } = useDrugSearchBar();

  return (
    <div className={'drugSearchBar'}>
      <Button
        outlined
        data-testid="drugSearchButton"
        className="searchIconButton"
        onClick={handleSearch}
        disabled={isSearchButtonDisabled()}
      >
        {!isAllDrugsLoading && !isConceptsListLoading ? (
          <img className="searchIcon" src={SearchIcon} alt="search icon" />
        ) : (
          <ProgressSpinner
            style={{ width: '25px', height: '25px' }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration="1s"
          />
        )}
      </Button>
      <Divider className="devider" layout="vertical" />
      <div className={'searchBarRightSide'}>
        <AutoComplete
          onSelect={handleSearch}
          autoHighlight={true}
          delay={100}
          loadingIcon={null}
          onDropdownClick={() => console.log('clicked')}
          disabled={isAllDrugsLoading}
          onKeyDown={handleEnterKeyDownDrugSearchField}
          placeholder="Search a molecule for Active Drug Strategy Adjustments"
          style={{ flexGrow: 1 }}
          className={'searchField'}
          value={drugSearchInput}
          suggestions={filteredDrugMoleculesForSearch}
          dropdownIcon={null}
          completeMethod={handleFilterDrugSearch}
          onChange={e => handleDrugSearchInputChange(e.value)}
        />
      </div>
    </div>
  );
};

export default observer(DrugSearchBar);
